import React from 'react';
import BirdMascot from './BirdMascot';

// 20 Cute Bird Avatar Options - User will choose 10 favorites
export const AVATAR_OPTIONS = [
  { id: 1, color: '#FF6B9D', accessory: 'none', name: 'Bubblegum', description: 'Sweet & Classic' },
  { id: 2, color: '#4ECDC4', accessory: 'tiny-glasses', name: 'Smarty', description: 'Nerdy & Proud' },
  { id: 3, color: '#FFD93D', accessory: 'tiny-bow', name: 'Sunny', description: 'Bright & Cheerful' },
  { id: 4, color: '#A8E6CF', accessory: 'little-hat', name: 'Detective', description: 'Always Investigating' },
  { id: 5, color: '#FF8ED4', accessory: 'heart', name: 'Sweetheart', description: 'Full of Love' },
  { id: 6, color: '#C7A4FF', accessory: 'tiny-crown', name: 'Royal', description: 'Fancy & Fabulous' },
  { id: 7, color: '#FFB6C1', accessory: 'flower', name: 'Blossom', description: 'Pretty in Pink' },
  { id: 8, color: '#6FEDD6', accessory: 'star', name: 'Starry', description: 'Dreamy & Magical' },
  { id: 9, color: '#FFB347', accessory: 'cool-shades', name: 'Chill', description: 'Too Cool for School' },
  { id: 10, color: '#B19CD9', accessory: 'party-hat', name: 'Party', description: 'Always Celebrating' },
  { id: 11, color: '#77DD77', accessory: 'leaf', name: 'Sprout', description: 'Fresh & Green' },
  { id: 12, color: '#FDFD96', accessory: 'lightning', name: 'Zippy', description: 'Quick & Energetic' },
  { id: 13, color: '#FF6F61', accessory: 'bandana', name: 'Rebel', description: 'Wild & Free' },
  { id: 14, color: '#84B6F4', accessory: 'mustache', name: 'Gentleman', description: 'Classy & Dapper' },
  { id: 15, color: '#FDCAE1', accessory: 'cupcake', name: 'Sweetie', description: 'Sugar & Spice' },
  { id: 16, color: '#AEC6CF', accessory: 'cloud', name: 'Cloudy', description: 'Head in the Clouds' },
  { id: 17, color: '#FFD700', accessory: 'sparkle', name: 'Glitter', description: 'Sparkly & Shiny' },
  { id: 18, color: '#98D8C8', accessory: 'bubble', name: 'Bubbly', description: 'Fizzy & Fun' },
  { id: 19, color: '#F7B2BD', accessory: 'cherry', name: 'Cherry', description: 'Sweet & Juicy' },
  { id: 20, color: '#DDA0DD', accessory: 'butterfly', name: 'Flutter', description: 'Light & Graceful' },
  
  // 20 MORE ADORABLE OPTIONS
  { id: 21, color: '#FFB3E6', accessory: 'bunny-ears', name: 'Cottontail', description: 'Hoppy & Bouncy' },
  { id: 22, color: '#B4E7CE', accessory: 'donut', name: 'Sprinkles', description: 'Sweet as Sugar' },
  { id: 23, color: '#FFA5BA', accessory: 'cat-ears', name: 'Whiskers', description: 'Purr-fectly Cute' },
  { id: 24, color: '#A0E7E5', accessory: 'ice-cream', name: 'Frosty', description: 'Cool & Sweet' },
  { id: 25, color: '#FFAEBC', accessory: 'rainbow', name: 'Sunny Day', description: 'Colorful & Happy' },
  { id: 26, color: '#B4F8C8', accessory: 'bear-ears', name: 'Teddy', description: 'Cuddly & Warm' },
  { id: 27, color: '#FBE7C6', accessory: 'pizza', name: 'Pepperoni', description: 'Cheesy & Fun' },
  { id: 28, color: '#A0C4FF', accessory: 'moon', name: 'Dreamer', description: 'Sleepy & Peaceful' },
  { id: 29, color: '#FFCFD2', accessory: 'balloon', name: 'Float', description: 'Light as Air' },
  { id: 30, color: '#CFBAF0', accessory: 'wink', name: 'Cheeky', description: 'Playful Wink' },
  { id: 31, color: '#90DBF4', accessory: 'music-note', name: 'Melody', description: 'Always Singing' },
  { id: 32, color: '#FFED4E', accessory: 'sunburst', name: 'Sunshine', description: 'Bright & Warm' },
  { id: 33, color: '#FFD1DC', accessory: 'lollipop', name: 'Candy', description: 'Super Sweet' },
  { id: 34, color: '#B9FBC0', accessory: 'game-controller', name: 'Gamer', description: 'Ready to Play' },
  { id: 35, color: '#FEC8D8', accessory: 'present', name: 'Gift', description: 'Full of Surprises' },
  { id: 36, color: '#D4F1F4', accessory: 'snowflake', name: 'Frosty', description: 'Cool & Crisp' },
  { id: 37, color: '#FFB7B2', accessory: 'bee-wings', name: 'Buzzy', description: 'Busy Bee' },
  { id: 38, color: '#E2F0CB', accessory: 'cactus', name: 'Prickles', description: 'Sharp but Sweet' },
  { id: 39, color: '#FFDFD3', accessory: 'cookie', name: 'Chips', description: 'Freshly Baked' },
  { id: 40, color: '#C9CBA3', accessory: 'peace-sign', name: 'Peaceful', description: 'Calm & Zen' },
  
  // 10 BRAND NEW SUPER CUTE OPTIONS (41-50)
  { id: 41, color: '#FFFFFF', accessory: 'panda', name: 'Bamboo', description: 'Cuddly Panda' },
  { id: 42, color: '#FFB3FF', accessory: 'unicorn', name: 'Magic', description: 'Sparkly Unicorn' },
  { id: 43, color: '#FF6B6B', accessory: 'strawberry', name: 'Berry', description: 'Sweet Berry' },
  { id: 44, color: '#8B7355', accessory: 'coffee', name: 'Mocha', description: 'Cozy Café' },
  { id: 45, color: '#90EE90', accessory: 'frog-hat', name: 'Hoppy', description: 'Froggy Friend' },
  { id: 46, color: '#E0E0E0', accessory: 'astronaut', name: 'Cosmo', description: 'Space Explorer' },
  { id: 47, color: '#9370DB', accessory: 'witch-hat', name: 'Spooky', description: 'Magical Witch' },
  { id: 48, color: '#FFB6C1', accessory: 'headphones', name: 'Beats', description: 'Music Lover' },
  { id: 49, color: '#FFE5B4', accessory: 'sushi', name: 'Wasabi', description: 'Sushi Roll' },
  { id: 50, color: '#C1E1C1', accessory: 'avocado', name: 'Guac', description: 'Avo-cutie' }
];

// Custom accessory renderer for cute simple accessories
const renderCuteAccessory = (accessory, size) => {
  const scale = size / 40; // Base scale
  
  switch (accessory) {
    case 'tiny-glasses':
      return (
        <g>
          <circle cx={size/2 - 6} cy={size/2 - 2} r={4 * scale} fill="none" stroke="#333" strokeWidth={1.5} />
          <circle cx={size/2 + 6} cy={size/2 - 2} r={4 * scale} fill="none" stroke="#333" strokeWidth={1.5} />
          <line x1={size/2 - 2} y1={size/2 - 2} x2={size/2 + 2} y2={size/2 - 2} stroke="#333" strokeWidth={1.5} />
        </g>
      );
    
    case 'tiny-bow':
      return (
        <g>
          <path d={`M ${size/2 - 8} ${size/2 - 12} Q ${size/2 - 5} ${size/2 - 14} ${size/2 - 4} ${size/2 - 10}`} fill="#FF1493" />
          <path d={`M ${size/2 + 8} ${size/2 - 12} Q ${size/2 + 5} ${size/2 - 14} ${size/2 + 4} ${size/2 - 10}`} fill="#FF1493" />
          <circle cx={size/2} cy={size/2 - 11} r={2 * scale} fill="#FF1493" />
        </g>
      );
    
    case 'little-hat':
      return (
        <g>
          <ellipse cx={size/2} cy={size/2 - 12} rx={10 * scale} ry={2 * scale} fill="#2C3E50" />
          <rect x={size/2 - 6 * scale} y={size/2 - 18} width={12 * scale} height={6 * scale} rx={1} fill="#2C3E50" />
        </g>
      );
    
    case 'heart':
      return (
        <g>
          <path d={`M ${size/2} ${size/2 - 8} L ${size/2 - 3} ${size/2 - 12} Q ${size/2 - 5} ${size/2 - 14} ${size/2 - 3} ${size/2 - 15} Q ${size/2} ${size/2 - 16} ${size/2} ${size/2 - 14} Q ${size/2} ${size/2 - 16} ${size/2 + 3} ${size/2 - 15} Q ${size/2 + 5} ${size/2 - 14} ${size/2 + 3} ${size/2 - 12} Z`} fill="#FF69B4" />
        </g>
      );
    
    case 'tiny-crown':
      return (
        <g>
          <path d={`M ${size/2 - 8} ${size/2 - 12} L ${size/2 - 6} ${size/2 - 16} L ${size/2 - 3} ${size/2 - 13} L ${size/2} ${size/2 - 18} L ${size/2 + 3} ${size/2 - 13} L ${size/2 + 6} ${size/2 - 16} L ${size/2 + 8} ${size/2 - 12} Z`} fill="#FFD700" />
        </g>
      );
    
    case 'flower':
      return (
        <g>
          <circle cx={size/2 - 6} cy={size/2 - 14} r={2 * scale} fill="#FFB6C1" />
          <circle cx={size/2 - 3} cy={size/2 - 16} r={2 * scale} fill="#FFB6C1" />
          <circle cx={size/2} cy={size/2 - 14} r={2 * scale} fill="#FFB6C1" />
          <circle cx={size/2 - 3} cy={size/2 - 12} r={2 * scale} fill="#FFB6C1" />
          <circle cx={size/2 - 3} cy={size/2 - 14} r={1.5 * scale} fill="#FFD700" />
        </g>
      );
    
    case 'star':
      return (
        <g>
          <path d={`M ${size/2} ${size/2 - 18} L ${size/2 + 2} ${size/2 - 14} L ${size/2 + 6} ${size/2 - 13} L ${size/2 + 3} ${size/2 - 10} L ${size/2 + 4} ${size/2 - 6} L ${size/2} ${size/2 - 8} L ${size/2 - 4} ${size/2 - 6} L ${size/2 - 3} ${size/2 - 10} L ${size/2 - 6} ${size/2 - 13} L ${size/2 - 2} ${size/2 - 14} Z`} fill="#FFD700" />
        </g>
      );
    
    case 'cool-shades':
      return (
        <g>
          <rect x={size/2 - 10} y={size/2 - 6} width={8 * scale} height={5 * scale} rx={1} fill="#000" />
          <rect x={size/2 + 2} y={size/2 - 6} width={8 * scale} height={5 * scale} rx={1} fill="#000" />
          <line x1={size/2 - 2} y1={size/2 - 3} x2={size/2 + 2} y2={size/2 - 3} stroke="#000" strokeWidth={1.5} />
        </g>
      );
    
    case 'party-hat':
      return (
        <g>
          <path d={`M ${size/2 - 8} ${size/2 - 12} L ${size/2} ${size/2 - 20} L ${size/2 + 8} ${size/2 - 12} Z`} fill="#FF1493" />
          <circle cx={size/2} cy={size/2 - 20} r={1.5 * scale} fill="#FFD700" />
        </g>
      );
    
    case 'leaf':
      return (
        <g>
          <path d={`M ${size/2 - 4} ${size/2 - 14} Q ${size/2 - 8} ${size/2 - 16} ${size/2 - 6} ${size/2 - 18} Q ${size/2 - 4} ${size/2 - 16} ${size/2 - 4} ${size/2 - 14}`} fill="#228B22" />
        </g>
      );
    
    case 'lightning':
      return (
        <g>
          <path d={`M ${size/2 + 2} ${size/2 - 18} L ${size/2 - 2} ${size/2 - 12} L ${size/2 + 1} ${size/2 - 12} L ${size/2 - 2} ${size/2 - 6} L ${size/2 + 4} ${size/2 - 11} L ${size/2 + 2} ${size/2 - 11} Z`} fill="#FFD700" />
        </g>
      );
    
    case 'bandana':
      return (
        <g>
          <path d={`M ${size/2 - 10} ${size/2 - 10} L ${size/2 + 10} ${size/2 - 10} L ${size/2 + 8} ${size/2 - 14} L ${size/2 - 8} ${size/2 - 14} Z`} fill="#FF4444" />
          <circle cx={size/2 - 4} cy={size/2 - 12} r={1} fill="white" />
          <circle cx={size/2 + 4} cy={size/2 - 12} r={1} fill="white" />
        </g>
      );
    
    case 'mustache':
      return (
        <g>
          <ellipse cx={size/2 - 5} cy={size/2 + 4} rx={4 * scale} ry={2 * scale} fill="#2C3E50" />
          <ellipse cx={size/2 + 5} cy={size/2 + 4} rx={4 * scale} ry={2 * scale} fill="#2C3E50" />
        </g>
      );
    
    case 'cupcake':
      return (
        <g>
          <path d={`M ${size/2 - 4} ${size/2 - 10} L ${size/2 - 5} ${size/2 - 14} L ${size/2 + 5} ${size/2 - 14} L ${size/2 + 4} ${size/2 - 10} Z`} fill="#FFB6C1" />
          <ellipse cx={size/2} cy={size/2 - 14} rx={4 * scale} ry={2 * scale} fill="#FF69B4" />
        </g>
      );
    
    case 'cloud':
      return (
        <g>
          <circle cx={size/2 - 4} cy={size/2 - 14} r={2.5 * scale} fill="white" opacity="0.9" />
          <circle cx={size/2} cy={size/2 - 15} r={3 * scale} fill="white" opacity="0.9" />
          <circle cx={size/2 + 4} cy={size/2 - 14} r={2.5 * scale} fill="white" opacity="0.9" />
        </g>
      );
    
    case 'sparkle':
      return (
        <g>
          <path d={`M ${size/2 - 6} ${size/2 - 14} L ${size/2 - 5} ${size/2 - 12} L ${size/2 - 4} ${size/2 - 14} L ${size/2 - 5} ${size/2 - 16} Z`} fill="#FFD700" />
          <path d={`M ${size/2 + 4} ${size/2 - 16} L ${size/2 + 5} ${size/2 - 14} L ${size/2 + 6} ${size/2 - 16} L ${size/2 + 5} ${size/2 - 18} Z`} fill="#FFD700" />
        </g>
      );
    
    case 'bubble':
      return (
        <g>
          <circle cx={size/2 - 5} cy={size/2 - 14} r={2 * scale} fill="none" stroke="#6FEDD6" strokeWidth={1} opacity="0.7" />
          <circle cx={size/2 + 3} cy={size/2 - 16} r={1.5 * scale} fill="none" stroke="#6FEDD6" strokeWidth={1} opacity="0.7" />
          <circle cx={size/2 + 1} cy={size/2 - 12} r={1 * scale} fill="none" stroke="#6FEDD6" strokeWidth={1} opacity="0.7" />
        </g>
      );
    
    case 'cherry':
      return (
        <g>
          <circle cx={size/2 - 3} cy={size/2 - 12} r={2 * scale} fill="#FF0000" />
          <circle cx={size/2 + 2} cy={size/2 - 13} r={2 * scale} fill="#FF0000" />
          <path d={`M ${size/2 - 3} ${size/2 - 14} Q ${size/2} ${size/2 - 18} ${size/2 + 2} ${size/2 - 15}`} stroke="#228B22" strokeWidth={1} fill="none" />
        </g>
      );
    
    case 'butterfly':
      return (
        <g>
          <path d={`M ${size/2 - 6} ${size/2 - 14} Q ${size/2 - 8} ${size/2 - 16} ${size/2 - 6} ${size/2 - 18} Q ${size/2 - 4} ${size/2 - 16} ${size/2 - 5} ${size/2 - 14}`} fill="#DDA0DD" />
          <path d={`M ${size/2 + 6} ${size/2 - 14} Q ${size/2 + 8} ${size/2 - 16} ${size/2 + 6} ${size/2 - 18} Q ${size/2 + 4} ${size/2 - 16} ${size/2 + 5} ${size/2 - 14}`} fill="#DDA0DD" />
          <line x1={size/2} y1={size/2 - 14} x2={size/2} y2={size/2 - 18} stroke="#8B008B" strokeWidth={1} />
        </g>
      );
    
    // NEW ADORABLE ACCESSORIES
    case 'bunny-ears':
      return (
        <g>
          <ellipse cx={size/2 - 5} cy={size/2 - 18} rx={3 * scale} ry={7 * scale} fill="#FFB3E6" stroke="#FF69B4" strokeWidth={1} />
          <ellipse cx={size/2 + 5} cy={size/2 - 18} rx={3 * scale} ry={7 * scale} fill="#FFB3E6" stroke="#FF69B4" strokeWidth={1} />
          <ellipse cx={size/2 - 5} cy={size/2 - 18} rx={1.5 * scale} ry={4 * scale} fill="#FFC0CB" />
          <ellipse cx={size/2 + 5} cy={size/2 - 18} rx={1.5 * scale} ry={4 * scale} fill="#FFC0CB" />
        </g>
      );
    
    case 'donut':
      return (
        <g>
          <circle cx={size/2} cy={size/2 - 15} r={5 * scale} fill="#FFB6C1" />
          <circle cx={size/2} cy={size/2 - 15} r={2 * scale} fill="#FFF" />
          <circle cx={size/2 - 2} cy={size/2 - 17} r={0.8 * scale} fill="#FF1493" />
          <circle cx={size/2 + 2} cy={size/2 - 17} r={0.8 * scale} fill="#4169E1" />
          <circle cx={size/2} cy={size/2 - 13} r={0.8 * scale} fill="#FFD700" />
        </g>
      );
    
    case 'cat-ears':
      return (
        <g>
          <path d={`M ${size/2 - 8} ${size/2 - 12} L ${size/2 - 5} ${size/2 - 20} L ${size/2 - 3} ${size/2 - 12} Z`} fill="#FFA5BA" />
          <path d={`M ${size/2 + 8} ${size/2 - 12} L ${size/2 + 5} ${size/2 - 20} L ${size/2 + 3} ${size/2 - 12} Z`} fill="#FFA5BA" />
          <path d={`M ${size/2 - 7} ${size/2 - 12} L ${size/2 - 5} ${size/2 - 17} L ${size/2 - 4} ${size/2 - 12} Z`} fill="#FF69B4" />
          <path d={`M ${size/2 + 7} ${size/2 - 12} L ${size/2 + 5} ${size/2 - 17} L ${size/2 + 4} ${size/2 - 12} Z`} fill="#FF69B4" />
        </g>
      );
    
    case 'ice-cream':
      return (
        <g>
          <path d={`M ${size/2 - 3} ${size/2 - 10} L ${size/2} ${size/2 - 4} L ${size/2 + 3} ${size/2 - 10} Z`} fill="#F4A460" />
          <circle cx={size/2} cy={size/2 - 12} r={4 * scale} fill="#FFB6C1" />
          <circle cx={size/2 - 2} cy={size/2 - 15} r={3 * scale} fill="#E6E6FA" />
          <circle cx={size/2 + 2} cy={size/2 - 15} r={3 * scale} fill="#98D8C8" />
        </g>
      );
    
    case 'rainbow':
      return (
        <g>
          <path d={`M ${size/2 - 10} ${size/2 - 10} Q ${size/2} ${size/2 - 18} ${size/2 + 10} ${size/2 - 10}`} stroke="#FF0000" strokeWidth={1.5} fill="none" />
          <path d={`M ${size/2 - 9} ${size/2 - 10} Q ${size/2} ${size/2 - 17} ${size/2 + 9} ${size/2 - 10}`} stroke="#FFA500" strokeWidth={1.5} fill="none" />
          <path d={`M ${size/2 - 8} ${size/2 - 10} Q ${size/2} ${size/2 - 16} ${size/2 + 8} ${size/2 - 10}`} stroke="#FFFF00" strokeWidth={1.5} fill="none" />
          <path d={`M ${size/2 - 7} ${size/2 - 10} Q ${size/2} ${size/2 - 15} ${size/2 + 7} ${size/2 - 10}`} stroke="#00FF00" strokeWidth={1.5} fill="none" />
        </g>
      );
    
    case 'bear-ears':
      return (
        <g>
          <circle cx={size/2 - 7} cy={size/2 - 16} r={4 * scale} fill="#B4F8C8" stroke="#8B4513" strokeWidth={1} />
          <circle cx={size/2 + 7} cy={size/2 - 16} r={4 * scale} fill="#B4F8C8" stroke="#8B4513" strokeWidth={1} />
          <circle cx={size/2 - 7} cy={size/2 - 16} r={2 * scale} fill="#DEB887" />
          <circle cx={size/2 + 7} cy={size/2 - 16} r={2 * scale} fill="#DEB887" />
        </g>
      );
    
    case 'pizza':
      return (
        <g>
          <path d={`M ${size/2 - 6} ${size/2 - 10} L ${size/2} ${size/2 - 18} L ${size/2 + 6} ${size/2 - 10} Z`} fill="#FFD700" />
          <circle cx={size/2 - 2} cy={size/2 - 13} r={1.2 * scale} fill="#FF4500" />
          <circle cx={size/2 + 2} cy={size/2 - 13} r={1.2 * scale} fill="#FF4500" />
          <circle cx={size/2} cy={size/2 - 15} r={1.2 * scale} fill="#FF4500" />
        </g>
      );
    
    case 'moon':
      return (
        <g>
          <circle cx={size/2} cy={size/2 - 15} r={5 * scale} fill="#FFF9C4" />
          <circle cx={size/2 + 2} cy={size/2 - 15} r={4 * scale} fill="#A0C4FF" />
          <circle cx={size/2 - 3} cy={size/2 - 16} r={0.8 * scale} fill="#FFD700" />
        </g>
      );
    
    case 'balloon':
      return (
        <g>
          <ellipse cx={size/2} cy={size/2 - 16} rx={4 * scale} ry={5 * scale} fill="#FF69B4" />
          <path d={`M ${size/2} ${size/2 - 11} Q ${size/2 - 2} ${size/2 - 8} ${size/2 - 3} ${size/2 - 6}`} stroke="#FF1493" strokeWidth={1} fill="none" />
          <circle cx={size/2 - 1} cy={size/2 - 17} r={0.8 * scale} fill="#FFF" opacity="0.7" />
        </g>
      );
    
    case 'wink':
      return (
        <g>
          <circle cx={size/2 - 6} cy={size/2 - 2} r={1 * scale} fill="#FF69B4" />
          <path d={`M ${size/2 + 4} ${size/2 - 2} Q ${size/2 + 6} ${size/2 - 4} ${size/2 + 8} ${size/2 - 2}`} stroke="#FF69B4" strokeWidth={1.5} fill="none" />
        </g>
      );
    
    case 'music-note':
      return (
        <g>
          <circle cx={size/2 - 2} cy={size/2 - 10} r={2 * scale} fill="#000" />
          <rect x={size/2 - 2} y={size/2 - 18} width={1.5} height={8 * scale} fill="#000" />
          <path d={`M ${size/2 - 2} ${size/2 - 18} Q ${size/2 + 4} ${size/2 - 20} ${size/2 + 4} ${size/2 - 14}`} stroke="#000" strokeWidth={1.5} fill="none" />
        </g>
      );
    
    case 'sunburst':
      return (
        <g>
          <circle cx={size/2} cy={size/2 - 15} r={3 * scale} fill="#FFD700" />
          {[0, 45, 90, 135, 180, 225, 270, 315].map(angle => {
            const rad = (angle * Math.PI) / 180;
            const x1 = size/2 + Math.cos(rad) * 4 * scale;
            const y1 = size/2 - 15 + Math.sin(rad) * 4 * scale;
            const x2 = size/2 + Math.cos(rad) * 7 * scale;
            const y2 = size/2 - 15 + Math.sin(rad) * 7 * scale;
            return <line key={angle} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#FFA500" strokeWidth={1.5} />;
          })}
        </g>
      );
    
    case 'lollipop':
      return (
        <g>
          <circle cx={size/2} cy={size/2 - 16} r={4 * scale} fill="#FF69B4" />
          <path d={`M ${size/2 - 4} ${size/2 - 16} Q ${size/2 - 2} ${size/2 - 18} ${size/2} ${size/2 - 16} Q ${size/2 + 2} ${size/2 - 14} ${size/2 + 4} ${size/2 - 16}`} stroke="#FFF" strokeWidth={1} fill="none" />
          <line x1={size/2} y1={size/2 - 12} x2={size/2} y2={size/2 - 8} stroke="#8B4513" strokeWidth={2} />
        </g>
      );
    
    case 'game-controller':
      return (
        <g>
          <rect x={size/2 - 6} y={size/2 - 16} width={12 * scale} height={6 * scale} rx={2} fill="#9370DB" />
          <circle cx={size/2 - 3} cy={size/2 - 13} r={1 * scale} fill="#FF0000" />
          <circle cx={size/2 + 3} cy={size/2 - 13} r={1 * scale} fill="#00FF00" />
        </g>
      );
    
    case 'present':
      return (
        <g>
          <rect x={size/2 - 5} y={size/2 - 16} width={10 * scale} height={8 * scale} rx={1} fill="#FF69B4" />
          <rect x={size/2 - 1} y={size/2 - 16} width={2} height={8 * scale} fill="#FFD700" />
          <path d={`M ${size/2 - 4} ${size/2 - 18} Q ${size/2} ${size/2 - 22} ${size/2 + 4} ${size/2 - 18}`} fill="#FFD700" />
        </g>
      );
    
    case 'snowflake':
      return (
        <g>
          <line x1={size/2} y1={size/2 - 20} x2={size/2} y2={size/2 - 10} stroke="#B0E0E6" strokeWidth={1.5} />
          <line x1={size/2 - 5} y1={size/2 - 15} x2={size/2 + 5} y2={size/2 - 15} stroke="#B0E0E6" strokeWidth={1.5} />
          <line x1={size/2 - 3} y1={size/2 - 18} x2={size/2 + 3} y2={size/2 - 12} stroke="#B0E0E6" strokeWidth={1.5} />
          <line x1={size/2 + 3} y1={size/2 - 18} x2={size/2 - 3} y2={size/2 - 12} stroke="#B0E0E6" strokeWidth={1.5} />
        </g>
      );
    
    case 'bee-wings':
      return (
        <g>
          <ellipse cx={size/2 - 6} cy={size/2 - 12} rx={4 * scale} ry={5 * scale} fill="#FFF" opacity="0.6" stroke="#FFD700" strokeWidth={1} />
          <ellipse cx={size/2 + 6} cy={size/2 - 12} rx={4 * scale} ry={5 * scale} fill="#FFF" opacity="0.6" stroke="#FFD700" strokeWidth={1} />
          <rect x={size/2 - 1} y={size/2 - 2} width={2} height={3} fill="#FFD700" />
          <rect x={size/2 - 1} y={size/2 + 2} width={2} height={2} fill="#000" />
        </g>
      );
    
    case 'cactus':
      return (
        <g>
          <rect x={size/2 - 2} y={size/2 - 16} width={4} height={10 * scale} rx={2} fill="#228B22" />
          <rect x={size/2 - 4} y={size/2 - 12} width={3} height={5 * scale} rx={1.5} fill="#228B22" />
          <rect x={size/2 + 1} y={size/2 - 13} width={3} height={5 * scale} rx={1.5} fill="#228B22" />
          <circle cx={size/2} cy={size/2 - 10} r={0.5} fill="#FF69B4" />
        </g>
      );
    
    case 'cookie':
      return (
        <g>
          <circle cx={size/2} cy={size/2 - 14} r={5 * scale} fill="#D2691E" />
          <circle cx={size/2 - 2} cy={size/2 - 15} r={1 * scale} fill="#8B4513" />
          <circle cx={size/2 + 2} cy={size/2 - 15} r={1 * scale} fill="#8B4513" />
          <circle cx={size/2} cy={size/2 - 12} r={1 * scale} fill="#8B4513" />
          <circle cx={size/2 - 1} cy={size/2 - 16} r={0.5} fill="#F5DEB3" />
        </g>
      );
    
    case 'peace-sign':
      return (
        <g>
          <circle cx={size/2} cy={size/2 - 14} r={5 * scale} fill="none" stroke="#9370DB" strokeWidth={2} />
          <line x1={size/2} y1={size/2 - 14} x2={size/2} y2={size/2 - 9} stroke="#9370DB" strokeWidth={2} />
          <line x1={size/2} y1={size/2 - 14} x2={size/2 - 3} y2={size/2 - 11} stroke="#9370DB" strokeWidth={2} />
          <line x1={size/2} y1={size/2 - 14} x2={size/2 + 3} y2={size/2 - 11} stroke="#9370DB" strokeWidth={2} />
        </g>
      );
    
    // 10 BRAND NEW ADORABLE ACCESSORIES
    case 'panda':
      return (
        <g>
          {/* Panda ears and eye patches */}
          <circle cx={size/2 - 7} cy={size/2 - 16} r={4 * scale} fill="#000" />
          <circle cx={size/2 + 7} cy={size/2 - 16} r={4 * scale} fill="#000" />
          <ellipse cx={size/2 - 6} cy={size/2 - 2} rx={3 * scale} ry={4 * scale} fill="#000" />
          <ellipse cx={size/2 + 6} cy={size/2 - 2} rx={3 * scale} ry={4 * scale} fill="#000" />
        </g>
      );
    
    case 'unicorn':
      return (
        <g>
          {/* Unicorn horn */}
          <path d={`M ${size/2 - 2} ${size/2 - 12} L ${size/2} ${size/2 - 22} L ${size/2 + 2} ${size/2 - 12} Z`} fill="#FFD700" />
          <line x1={size/2} y1={size/2 - 20} x2={size/2 - 1} y2={size/2 - 16} stroke="#FFA500" strokeWidth={1} />
          <line x1={size/2} y1={size/2 - 18} x2={size/2 - 1} y2={size/2 - 14} stroke="#FFA500" strokeWidth={1} />
          {/* Sparkles */}
          <circle cx={size/2 - 5} cy={size/2 - 18} r={1} fill="#FFD700" />
          <circle cx={size/2 + 5} cy={size/2 - 16} r={1} fill="#FFD700" />
        </g>
      );
    
    case 'strawberry':
      return (
        <g>
          {/* Strawberry on head */}
          <path d={`M ${size/2 - 4} ${size/2 - 12} L ${size/2} ${size/2 - 18} L ${size/2 + 4} ${size/2 - 12} Q ${size/2} ${size/2 - 10} ${size/2 - 4} ${size/2 - 12}`} fill="#FF6B6B" />
          <path d={`M ${size/2 - 2} ${size/2 - 18} L ${size/2 - 3} ${size/2 - 20} L ${size/2} ${size/2 - 21} L ${size/2 + 3} ${size/2 - 20} L ${size/2 + 2} ${size/2 - 18}`} fill="#228B22" />
          <circle cx={size/2 - 2} cy={size/2 - 14} r={0.5} fill="#FFE4B5" />
          <circle cx={size/2 + 1} cy={size/2 - 15} r={0.5} fill="#FFE4B5" />
        </g>
      );
    
    case 'coffee':
      return (
        <g>
          {/* Coffee cup */}
          <rect x={size/2 - 4} y={size/2 - 16} width={8 * scale} height={7 * scale} rx={1} fill="#8B7355" />
          <ellipse cx={size/2} cy={size/2 - 16} rx={4 * scale} ry={1.5 * scale} fill="#6F4E37" />
          <path d={`M ${size/2 + 4} ${size/2 - 14} Q ${size/2 + 7} ${size/2 - 14} ${size/2 + 7} ${size/2 - 11}`} stroke="#8B7355" strokeWidth={1} fill="none" />
          {/* Steam */}
          <path d={`M ${size/2 - 2} ${size/2 - 17} Q ${size/2 - 1} ${size/2 - 19} ${size/2 - 2} ${size/2 - 20}`} stroke="#FFF" strokeWidth={0.8} fill="none" opacity="0.5" />
        </g>
      );
    
    case 'frog-hat':
      return (
        <g>
          {/* Frog hat */}
          <ellipse cx={size/2} cy={size/2 - 14} rx={8 * scale} ry={6 * scale} fill="#90EE90" />
          <circle cx={size/2 - 4} cy={size/2 - 16} r={2.5 * scale} fill="#FFF" />
          <circle cx={size/2 + 4} cy={size/2 - 16} r={2.5 * scale} fill="#FFF" />
          <circle cx={size/2 - 4} cy={size/2 - 16} r={1.5 * scale} fill="#000" />
          <circle cx={size/2 + 4} cy={size/2 - 16} r={1.5 * scale} fill="#000" />
        </g>
      );
    
    case 'astronaut':
      return (
        <g>
          {/* Helmet */}
          <circle cx={size/2} cy={size/2 - 2} r={11 * scale} fill="none" stroke="#E0E0E0" strokeWidth={2} opacity="0.3" />
          <path d={`M ${size/2 - 8} ${size/2 + 4} Q ${size/2} ${size/2 + 8} ${size/2 + 8} ${size/2 + 4}`} stroke="#E0E0E0" strokeWidth={2} fill="none" />
          {/* Antenna */}
          <line x1={size/2} y1={size/2 - 13} x2={size/2} y2={size/2 - 18} stroke="#C0C0C0" strokeWidth={1.5} />
          <circle cx={size/2} cy={size/2 - 18} r={1.5 * scale} fill="#FF0000" />
        </g>
      );
    
    case 'witch-hat':
      return (
        <g>
          {/* Witch hat */}
          <ellipse cx={size/2} cy={size/2 - 12} rx={10 * scale} ry={2 * scale} fill="#4B0082" />
          <path d={`M ${size/2 - 6} ${size/2 - 12} L ${size/2} ${size/2 - 24} L ${size/2 + 6} ${size/2 - 12}`} fill="#4B0082" />
          <rect x={size/2 - 8} y={size/2 - 14} width={16 * scale} height={2} fill="#FF8C00" />
        </g>
      );
    
    case 'headphones':
      return (
        <g>
          {/* Headphones */}
          <path d={`M ${size/2 - 10} ${size/2 - 2} Q ${size/2} ${size/2 - 20} ${size/2 + 10} ${size/2 - 2}`} stroke="#FFB6C1" strokeWidth={3} fill="none" />
          <rect x={size/2 - 12} y={size/2 - 4} width={5 * scale} height={8 * scale} rx={2} fill="#FFB6C1" />
          <rect x={size/2 + 7} y={size/2 - 4} width={5 * scale} height={8 * scale} rx={2} fill="#FFB6C1" />
        </g>
      );
    
    case 'sushi':
      return (
        <g>
          {/* Sushi roll */}
          <ellipse cx={size/2} cy={size/2 - 14} rx={6 * scale} ry={4 * scale} fill="#FFF" />
          <ellipse cx={size/2} cy={size/2 - 14} rx={3 * scale} ry={2 * scale} fill="#FF6B6B" />
          <rect x={size/2 - 6} y={size/2 - 16} width={12 * scale} height={2} fill="#1a1a1a" />
        </g>
      );
    
    case 'avocado':
      return (
        <g>
          {/* Avocado */}
          <ellipse cx={size/2} cy={size/2 - 14} rx={5 * scale} ry={6 * scale} fill="#C1E1C1" />
          <ellipse cx={size/2} cy={size/2 - 14} rx={3 * scale} ry={4 * scale} fill="#F4E5C3" />
          <circle cx={size/2} cy={size/2 - 14} r={2 * scale} fill="#8B4513" />
        </g>
      );
    
    default:
      return null;
  }
};

const BirdAvatarOption = ({ option, size = 80 }) => {
  return (
    <div className="flex flex-col items-center">
      <div className="relative">
        <BirdMascot size={size} color={option.color} />
        <svg
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
          className="absolute top-0 left-0 pointer-events-none"
        >
          {renderCuteAccessory(option.accessory, size)}
        </svg>
      </div>
      <div className="text-center mt-2">
        <p className="font-semibold text-sm">{option.name}</p>
        <p className="text-xs text-muted-foreground">{option.description}</p>
      </div>
    </div>
  );
};

export default BirdAvatarOption;
